
import {getDbId, LS_TOKEN} from '@/shared/local.storage.utils';
import {Component, Prop, PropSync, Vue} from 'vue-property-decorator';

@Component
export default class SAccNavigation extends Vue {
  // Les props
  @Prop() private theme!: string;
  @PropSync('drawer') private isdraw!: boolean;

  // Les propriétés
  // Les propriétés calculées
  public get isFreetrial() {
    const db = getDbId()
    return db === 'freetrial' || 'sandbox'
  }
  // Les hooks
  // Les méthodes surveillées
  // Les méthodes d'instance
  private onQuit() {
    localStorage.removeItem(LS_TOKEN)
    this.$router.go(0);
  }

  // Les méthodes statiques
}
